import GetAppSystemByIdRequestModelBase from '../_generated/modelBases/get-app-system-by-id-request-model-base';

export default class GetAppSystemByIdRequestModel extends GetAppSystemByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
